import { CheckFunction } from "../../../../../layouts/MainTenantconfig"

const tenant = CheckFunction();

const WEBSITE = tenant?.WEBSITE_URL;

const whoYouAre = [
    { code: 'CA', name: 'CA - Chartered Accountant' },
    { code: 'CS', name: 'CS - Company Secretary' },
    { code: 'CWA', name: 'CWA - Costs and Works Professional' },
    { code: 'DSA', name: 'DSA -  Direct Selling Agent' },
    { code: 'BANKER', name: 'BANKER - Banker' },
    { code: 'BUILDER', name: 'Real Estate Broker/Builder' },
    { code: 'ACCOUNTANT', name: 'Accountant' },
    { code: 'OTHERS', name: 'OTHERS' },

];

const sortingFunction = (allData, element, trigger, callBack) => {
    let array = allData
    console.log(allData)
    if (trigger === false) {
        array.sort(function (a, b) {
            if (a[element] < b[element]) { return -1; }
            if (a[element] > b[element]) { return 1; }
            return 0;
        });

    }
    if (trigger === true) {
        array.sort(function (a, b) {
            if (a[element] > b[element]) { return -1; }
            if (a[element] < b[element]) { return 1; }
            return 0;
        });

    }
    callBack({ data: array, trigger })

}

const paginationFuction = (type, pageNumber, totalCount, callBack) => {

    if (type === 'left') {
        if (pageNumber > 1) {
            callBack(pageNumber - 1)
        }
    }
    if (type === 'right') {
        if (JSON.stringify(totalCount / 10).includes('.')) {
            if (pageNumber + 1 <= (Math.ceil(totalCount / 10))) {
                callBack(pageNumber + 1)
            }
        } else {
            if (pageNumber + 1 < Math.round(totalCount / 10) + 1) {
                callBack(pageNumber + 1)
            }
        }
    }
    if (type === 'main-left') {
        if (pageNumber - 10 > 0) {
            callBack(pageNumber - 10)
        }
    }
    if (type === 'main-right') {
        if (pageNumber + 10 < totalCount / 10) {
            callBack(pageNumber + 10)
        } else {
        }
    }
}

const getExtensionAndUrlPrefixFromName = (docUrl) => {
    if(docUrl){
     const extension = docUrl.split('/')[docUrl.split('/').length - 1].toLowerCase()
     const finalExtension = extension.split('&')[0]
     return {
         extension: finalExtension,
         urlPrefix: finalExtension === 'pdf' ? "data:application/" : "data:image/"
     }
 
    }
 }

 const completeLoanTypeArr = [
    { code: 'personalloan', name: 'Personal Loan' },
    { code: 'businessloan', name: 'Business Loan' },
    { code: 'homeloan', name: 'Home Loan' },
    { code: 'lap', name: 'LAP(Loan Against Property)' },

]

const employmentTypeArr = [
    { code: 'businessprofessionalincome', name: 'Self Employed/Professional' },
    { code: 'salary', name: 'Salaried' },
    { code: 'housepropertyrental', name: 'House Property' }
]

const penaltyFeeType = [
    { code: 'penaltyFixedRateOfInterest', name: 'Penalty Fixed Rate Of Interest' },
    { code: 'variableRateOfPenalty', name: 'Variable Rate Of Penalty' }
]

const processingFeeAtDisbursment = [
    { code: true, name: 'Yes' },
    { code: false, name: 'No' }
]

const processingFeeType = [
    { code: 'fixedProcessingFee', name: 'Fixed Processing Fee' },
    { code: 'variableProcessingFee', name: 'Variable Processing Fee' }
]

const typeOfInterestRate = [
    { code: 'fixedRateOfInterest', name: 'Fixed Rate Of Interest' },
    { code: 'variableRateOfInterestOrReducingLoan', name: 'Variable Rate Of Interest Or Reducing Loan' }
]

const secureLoanTypeArr = [
    { code: 'homeloan', name: 'Home Loan' },
    { code: 'lap', name: 'LAP(Loan Against Property)' },
    { code: 'businessloan', name: 'Business Loan' },
    { code: 'other', name: 'Other' },

]

const unsecureLoanTypeArr = [
    { code: 'personalloan', name: 'Personal Loan' },
    { code: 'businessloan', name: 'Business Loan' },
    { code: 'other', name: 'Other' }

]

const loanSegmentArr = [
    { name: 'Secured Loan', code: 'secured' },
    { name: 'Unsecured Loan', code: 'unsecured' },
]

const borrowingTypeArr = [
    { name: 'Joint/Co-Borrower', code: 'joint' },
    { name: 'Primary Borrower', code: 'primary' },
]

const typeOfConsititutionArr = [
    { code: 'proprietorship', name: 'Proprietorship' },
    { code: 'partnership', name: 'Partnership' },
    { code: 'privatelimited', name: 'Private Limited' },
    { code: 'llp', name: 'LLP' }
]

const typeOfBusinessArr = [
    { code: 'trading', name: 'Trading' },
    { code: 'manufacturing', name: 'Manufacturing' },
    { code: 'service', name: 'Service' }
]

const loanForArray = [
    { code: 'SELF', name: 'Self' },
    { code: 'On behalf of Org.', name: 'On behalf of Org.' }
]

const businessTypeArray = [
    {
        name: 'Sole Proprietorship',
        code: 'Sole Proprietorship'
    },
    {
        name: 'Partnership',
        code: 'Partnership'
    },
    {
        name: 'Limited Liability Company (LLC)',
        code: 'Limited Liability Company (LLC)'
    },
    {
        name: 'Limited Liability PartnerShip (LLP)',
        code: 'Limited Liability PartnerShip (LLP)'
    }
]


const natureOfServiceArr = [
    {
        name: 'Manufacturing',
        code: 'manufacturing'
    },
    {
        name: 'Trading',
        code: 'trading'
    },
    {
        name: 'Service',
        code: 'service'
    },
    {
        name: 'Others',
        code: 'others'
    }
]

const educationArr = [
    { code: 'undergraduate', name: 'Under Graduate' },
    { code: 'graduate', name: 'Graduate' },
    { code: 'postgraduate', name: 'Post Graduate' }
]

const typeOfPropertyArr = [
    { code: 'residential', name: 'Residential' },
    { code: 'commercial', name: 'Commercial' },
    // { code: 'both', name: 'Both' }
]


export {
    whoYouAre ,sortingFunction, paginationFuction, getExtensionAndUrlPrefixFromName, completeLoanTypeArr,
    employmentTypeArr, penaltyFeeType, processingFeeAtDisbursment, processingFeeType, typeOfInterestRate, WEBSITE, secureLoanTypeArr, unsecureLoanTypeArr
    ,loanSegmentArr, borrowingTypeArr, typeOfConsititutionArr, typeOfBusinessArr, loanForArray, businessTypeArray, natureOfServiceArr,
    educationArr, typeOfPropertyArr
}